import { render, staticRenderFns } from "./SafetyApps.vue?vue&type=template&id=376390ef"
import script from "./SafetyApps.vue?vue&type=script&lang=js"
export * from "./SafetyApps.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports